export const itemModel = {
  id: "",
  name: "",
  title: "",
  sentence: "",
  body: "",
  label: "",
  color: "",
  index: "",
  linked: null,
  edit: false,
  linkedTo: [],
  children: [],
};

export const initialState = () => {
  return {
    id: "",
    name: "",
    title: "",
    sentence: "",
    body: "",
    label: "",
    color: "",
    index: "",
    edit: false,
    linkedTo: [],
    children: [],
  };
};

export const customColumns = (arr, item) => {
  const proto = {};
  if (arr) {
    arr.forEach((x) => {
      proto[x.name] = item[x.name] ? item[x.name] : [];
    });
    return proto;
  }
};

export const createItem = (item, model) => {
  const proto = {};
  Object.keys(model).forEach((key) => {
    proto[key] = item[key] ? item[key] : model[key];
  });
  return proto;
};

export const flattenArray = (arr) => {
  const local = [];
  arr.children.forEach((a) => {
    local.push({ name: a.name, id: a.id, color: a.color });
    a.children.forEach((b) => {
      local.push({ name: b.name, id: b.id, color: b.color });
      b.children.forEach((c) => {
        local.push({ name: c.name, id: c.id, color: c.color });
        c.children.forEach((d) => {
          local.push({ name: d.name, id: d.id, color: d.color });
          d.children.forEach((e) => {
            local.push({ name: e.name, id: e.id, color: e.color });
          });
        });
      });
    });
  });

  return local;
};

export const colors = [
  { title: "None", color: "" },
  { title: "Red", color: "#F44336" },
  { title: "Dark Red", color: "#B71C1C" },
  { title: "Pink", color: "#E91E63" },
  { title: "Purple", color: "#9C27B0" },
  { title: "Dark Purple", color: "#673AB7" },
  { title: "Light Purple", color: "#E1BEE7" },
  { title: "Indigo", color: "#3F51B5" },
  { title: "Blue", color: "#2196F3" },
  { title: "Light Blue", color: "#03A9F4" },
  { title: "Cyan", color: "#00BCD4" },
  { title: "Teal", color: "#009688" },
  { title: "Green", color: "#4CAF50" },
  { title: "Light Green", color: "#8BC34A" },
  { title: "Dark Green", color: "#1B5E20" },
  { title: "Yellow", color: "#FFEB3B" },
  { title: "Brown", color: "#795548" },
  { title: "Lime", color: "#CDDC39" },
  { title: "Amber", color: "#FFC107" },
  { title: "Orange", color: "#FF9800" },
  { title: "Deep Orange", color: "#FF5722" },
  { title: "Grey", color: "#607D8B" },
  { title: "Neutral Grey", color: "#9E9E9E" },
];
